"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div") `
  height: 1px;
  width: 100%;
  background-color: ${({ dark }) => `rgba(${dark ? "255,255,255" : "0,0,0"}, 0.14)`};
  margin: ${({ theme }) => theme.space.content}px 0;
`;
exports.SidenavSeparator = props => React.createElement(Container, Object.assign({}, props));
exports.default = exports.SidenavSeparator;
//# sourceMappingURL=SidenavSeparator.js.map